define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'lightbox'],
    function($, transit, modernizr, container, preloader, lightboxFactory)
    {

        return (function() {

            const name = 'layout';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const lightbox = lightboxFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {
            };

            model.privateVars = {
            };

            model.methods = {
                cookiesBar: {
                    sendCookieRequest: () => {
                        fetch(model.publicVars.cookiesBar.endpoint);
                    }
                }
            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                preloadMobileSet: false,

                menu: {
                    headerMenuOpened: false,
                    headerMenuAnim: false
                },

                cookiesBar: {
                    cookiesBarOpened: false
                }
            };

            view.startup = function() {

                $(view.publicVars.cssId.pageCls + ' iframe').each(function () {
                    this.src = this.src;
                });

                preloader.setPreloadBulk(name, view.publicVars.preloadImgTab);

                const width = $(window).width();

                if(width < 768) {
                    preloader.setPreloadBulk(name + '-mobile', view.publicVars.preloadMobileImgTab);
                    view.privateVars.preloadMobileSet = true;
                }
            };

            view.bind = function() {
                $(view.publicVars.cssId.menu.headerMenuIconId).click(function () {

                    const width = $(window).width();

                    if(width < 768) {
                        if (!view.privateVars.menu.headerMenuAnim) {
                            view.privateVars.menu.headerMenuAnim = true;
                            view.methods.menu.handleMenu();
                        }
                    }
                });

                $(document).click(function (e) {
                    var container = $(view.publicVars.cssId.menu.headerMenuCls);
                    const width = $(window).width();

                    if (!container.is(e.target) // if the target of the click isn't the container...
                        && width < 768
                        && container.has(e.target).length === 0
                        && view.privateVars.menu.headerMenuOpened) // ... nor a descendant of the container
                    {
                        view.methods.menu.handleMenuClose();
                    }
                });

                $(window).resize(() => {
                    if (!view.privateVars.preloadMobileSet) {
                        preloader.setPreloadBulk(name + '-mobile', view.publicVars.preloadMobileImgTab);
                        view.privateVars.preloadMobileSet = true;
                    }
                });

                $(window).on('orientationchange', () => {
                    if (!view.privateVars.preloadMobileSet) {
                        preloader.setPreloadBulk(name + '-mobile', view.publicVars.preloadMobileImgTab);
                        view.privateVars.preloadMobileSet = true;
                    }
                });

                $(document).on('click', view.publicVars.cssId.disclaimer.disclaimerCallCls, function () {

                    const src = container.getData($(this)[0], 'src');

                    $(view.publicVars.cssId.disclaimer.disclaimerBtnContinueId).attr('href', src);

                    lightbox.showLayer(function() {

                    });
                });

                $(view.publicVars.cssId.disclaimer.disclaimerBtnContinueId).click(function () {
                    if(lightbox.getStatus()) {
                        lightbox.close();
                    }
                });

                const cookiesBarButtonClose = document.querySelector(view.publicVars.cssId.cookiesBar.cookiesBarButtonCloseCls);

                if(cookiesBarButtonClose) {
                    cookiesBarButtonClose.addEventListener('click', () => {
                        if (!view.privateVars.cookiesBar.cookiesBarOpened) {
                            view.privateVars.cookiesBar.cookiesBarOpened = true;
                            view.methods.cookiesBar.closeCookiesBar();
                        }
                    });
                }
            };

            view.methods = {
                menu: {
                    handleMenu: () => {
                        if (!view.privateVars.menu.headerMenuOpened) {
                            view.methods.menu.handleMenuOpen();
                        } else {
                            view.methods.menu.handleMenuClose();
                        }
                    },

                    handleMenuOpen: () => {
                        view.privateVars.menu.headerMenuOpened = true;

                        $(view.publicVars.cssId.menu.headerMenuCls).addClass(view.publicVars.cssId.menu.isOpenedCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).css({transform: 'rotate(0deg)'});
                        $(view.publicVars.cssId.menu.headerMenuIconId).removeClass(view.publicVars.cssId.menu.canHoverCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).transit({rotate: '360deg'}, 300);

                        $(view.publicVars.cssId.menu.headerMenuInnerId).slideDown(300, () => {
                            $(view.publicVars.cssId.menu.headerMenuIconId).addClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                            view.privateVars.menu.headerMenuAnim = false;
                        });
                    },

                    handleMenuClose: () => {
                        view.privateVars.menu.headerMenuOpened = false;

                        $(view.publicVars.cssId.menu.headerMenuIconId).removeClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                        $(view.publicVars.cssId.menu.headerMenuCls).removeClass(view.publicVars.cssId.menu.isOpenedCls.substr(1));

                        $(view.publicVars.cssId.menu.headerMenuIconId).transit({rotate: '0deg'}, 300);

                        $(view.publicVars.cssId.menu.headerMenuInnerId).slideUp(300, () => {
                            $(view.publicVars.cssId.menu.headerMenuIconId).addClass(view.publicVars.cssId.menu.canHoverCls.substr(1));
                            view.privateVars.menu.headerMenuAnim = false;
                            $(view.publicVars.cssId.menu.headerMenuInnerId).removeAttr('style');
                        });
                    },
                },
                cookiesBar: {
                    closeCookiesBar: () => {
                        document.querySelector(view.publicVars.cssId.cookiesBar.cookiesBarCls)
                            .classList.add(view.publicVars.cssId.cookiesBar.isClosedCls.substr(1));

                        model.methods.cookiesBar.sendCookieRequest();

                        $(view.publicVars.cssId.cookiesBar.cookiesBarCls).slideUp(100, () => {
                            document.querySelector(view.publicVars.cssId.cookiesBar.cookiesBarCls).remove();
                        });
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function(options) {
                    model.init(options);
                    view.init(options);

                    lightbox.init(options.lightboxSetup);
                }
            };


        })();

    });